// src/pages/Departments/Lekha.js
export default function Lekha() {
  return (
    <div>
      <h2>लेखा विभाग</h2>
      <p>
        पंचायत समितीचे आर्थिक व्यवहार, लेखापरीक्षण, निधी वितरण,
        वार्षिक अंदाजपत्रक व हिशोब यांची जबाबदारी हा विभाग पाहतो.
      </p>
    </div>
  );
}

